export const LIST_ACCOUNT = 'LIST_ACCOUNT'
export const DETAIL_ACCOUNT = 'DETAIL_ACCOUNT'
